const GET_ALTERNATIVE_STORE = 'GET_ALTERNATIVE_STORE'

export { GET_ALTERNATIVE_STORE } // eslint-disable-line
